"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _Check = _interopRequireDefault(require("@mui/icons-material/Check"));
var _FlatButton = _interopRequireDefault(require("../FlatButton/FlatButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ContinueButton = function ContinueButton(props) {
  var _props$theme, _props$theme$button;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "continue-button flex-row",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FlatButton.default, {
      variant: "contained",
      disableElevation: true,
      onClick: function onClick() {
        return props.onSubmit(true);
      },
      sx: {
        margin: "1em 0",
        color: ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$button = _props$theme.button) === null || _props$theme$button === void 0 ? void 0 : _props$theme$button.color) || "black"
      },
      "data-testid": props.data.name + " Button",
      endIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Check.default, {
        fontWeight: "700",
        style: {
          fontSize: 25
        }
      }),
      children: props.data.buttonPrompt || "OK"
    }), props.showPressEnterMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "press-enter",
      children: "press Enter \u21B5"
    }) : null]
  });
};
var _default = ContinueButton;
exports.default = _default;